import React, { useState } from 'react';
import { makeStyles, useTheme } from 'utils/makeStylesAdapter';
import { CircularProgress, TextField, Tooltip, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddIcon from '@mui/icons-material/Add';
import { HeaderModal, ButtonConsensus } from 'components';
import inquiryService from 'services/inquiries/inquiryService';
import { toast } from 'react-toastify';
import history from 'utils/history';
import { colors } from 'utils/colorsSteps';
import colorsSteps from 'utils/colorsSteps';
import inquiriesService from 'services/inquiries/inquiryService';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
  },
  containerConfirm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    color: '#787878',
    fontSize: 16,
    fontWeight: 'bold',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  body: {
    padding: theme.spacing(2),
  },
  containerBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerBtnArea: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

const ModalNoticeAgreementNoncompliance = props => {
  const {
    inquiry,
    edit,
    open: externalOpen,
    onClose,
    wasNotifiedNoncomplianceAgreement,
    onSuccess,
  } = props;

  const classes = useStyles();
  const [formState, setFormState] = useState({
    values: { observation: inquiry.agreementNoncomplianceNoticeObservation || '' },
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const isOpen = externalOpen !== undefined ? externalOpen : open;

  React.useEffect(() => {
    if (isOpen) {
      setFormState({
        values: { observation: inquiry.agreementNoncomplianceNoticeObservation || '' },
      });
    }
  }, [isOpen, inquiry.agreementNoncomplianceNoticeObservation]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setOpen(false);
    }
    setFormState({ values: { observation: '' } });
  };

  const handleChange = event => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
    }));
  };

  const handleSaveNotice = async () => {
    const params = {
      agreementNoncomplianceNoticeObservation: formState.values.observation,
      wasNotifiedNoncomplianceAgreement: wasNotifiedNoncomplianceAgreement ?? true,
    };
    try {
      setLoading(true);
      await inquiriesService.updateInquiryInvestigatedService(inquiry.id, params);
      toast.success('Notificação adicionada com sucesso');

      inquiry.agreementNoncomplianceNoticeObservation = formState.values.observation;

      if (onSuccess) {
        onSuccess(wasNotifiedNoncomplianceAgreement ?? true);
      }

      handleClose();
    } catch (e) {
      toast.error('Falha ao tentar adicionar notificação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        maxWidth="md"
        open={isOpen}
        onClose={handleClose}
        className={classes.root}
        aria-labelledby="responsive-dialog-title"
        onClick={e => e.stopPropagation()}
      >
        <HeaderModal onClose={handleClose}>Salvar Notificação de Descumprimento</HeaderModal>
        <DialogContent className={classes.body}>
          {loading ? (
            <CircularProgress
              style={{ marginRight: '45%', marginLeft: '45%' }}
              color="primary"
              size={40}
            />
          ) : (
            <TextField
              multiline
              variant="outlined"
              fullWidth
              minRows={6}
              maxRows={10}
              label="Observação"
              name="observation"
              value={formState.values.observation}
              onChange={handleChange}
              size="small"
            />
          )}
          <div className={classes.actions}>
            <ButtonConsensus
              title="Salvar Notificação"
              backgroundColor={colors.primary}
              hovercolor={colors.primary}
              color="#fff"
              onClick={handleSaveNotice}
              disabled={loading}
            />
            <ButtonConsensus
              title="Cancelar"
              backgroundColor={colors.primary}
              hovercolor={colors.primary}
              color="#fff"
              onClick={handleClose}
              style={{ border: `1px solid ${colors.primary}` }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalNoticeAgreementNoncompliance;
